import React, {Component} from 'react';
import {Redirect, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {
    badgesFetchData,
} from './../../actions/FormationActions';
import ProgressBar from './ProgressBar';
import Heading from './Heading';
import NextBtn from './NextBtn';
import Badge from './Badge';
import common from './../../common';
import AdBottom from '../AdBottom';

class GetSelectBadge extends Component {
    isFooterInView = () => {
        const elem = document.querySelector('.footer-wrap');
        return common.isElementInViewport(elem);
    };
    onVisibilityChange = (callback) => {
        const _this = this;
        let old_visible;
        return function () {
            let visible = _this.isFooterInView();
            if (visible !== old_visible) {
                old_visible = visible;
                if (typeof callback === 'function') {
                    callback(visible);
                }
            }
        }
    };
    handler = this.onVisibilityChange(function (visibility) {
        if (this.nextBtn && this.dummyBtn) {
        if (visibility) {
            this.nextBtn.classList.remove('si-sticky-btn');
            this.dummyBtn.style.display = 'none';
        } else {
            this.nextBtn.classList.add('si-sticky-btn');
            this.dummyBtn.style.display = '';
        }}
    }.bind(this));

    componentDidMount() {
        this.props.fetchBadges(this.props.constraints.GamedayId);
        document.addEventListener('scroll', this.handler);
        this.handler();
    }

    componentWillUnmount() {
        document.removeEventListener('scroll', this.handler);
    }

    handleNext = () => {
        return this.props.history.push('/team-name');
    };

    render() {
        if (!this.props.teamData.captainID) {
            return <Redirect push to={'/select-captain'}/>
        }
        const wrapperClass = common.makeClasses({
            'si-main-component': true,
            'si-custom-team'   : true,
            'si-no-anim'       : true,
        });
        const data = this.props.badgesData.badges;
        const badgeID = this.props.teamData.badgeID;
        const isDisabled = badgeID === null;
        return <div className={wrapperClass}>
            <div className="si-container">
                <div className="si-top-section">
                    <ProgressBar/>
                    <Heading title={this.props.trans['choose_your_badge']} {...{isDisabled}}
                             text={this.props.trans.next}
                             showTitle={isDisabled} tooltipText={this.props.trans.select_your_badge}
                             handler={() => this.handleNext()}/>
                </div>
                <div className="si-cust-container si-badges-container si-flexBox">
                    {data.map(badge => {
                        const isSelected = badgeID === badge.Id;
                        return <Badge key={badge.Id} badge={badge} {...{isSelected}}/>
                    })}
                </div>
                <div className="si-btn-wrp si-dummy-btn" ref={(ref) => this.dummyBtn = ref}>
                    <div className="si-btn"><span>TEST</span></div>
                </div>
                <div className="si-btn-wrp" ref={(ref) => this.nextBtn = ref}>
                    <NextBtn {...{isDisabled}}
                             text={this.props.trans.next}
                             showTitle={isDisabled} tooltipText={this.props.trans.select_your_badge}
                             handler={() => this.handleNext()}/>
                </div>
                <AdBottom />
            </div>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        trans      : state.appData.trans,
        constraints: state.appData.constraints,
        badgesData : state.formationData.badgesData,
        teamData   : state.formationData.teamData,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        fetchBadges: (GamedayId) => dispatch(badgesFetchData(GamedayId)),
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GetSelectBadge));


// WEBPACK FOOTER //
// ./src/components/onboarding/GetSelectBadge.js